(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cmss-flagship-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
  const disclosure = event.target.closest('.cm-h details[open]');
  if (!disclosure) return;
  disclosure.open = false;
  disclosure.querySelector(':scope > summary').focus();
  event.preventDefault();
});
document.addEventListener('click', function(event) {
  document.querySelectorAll('.cm-h [data-cm-disclosure][open]').forEach(function(disclosure) {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  });
});
document.addEventListener('focusin', function(event) {
  document.querySelectorAll('.cm-h [data-cm-disclosure][open]').forEach(function(disclosure) {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cmss-flagship-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.cmssOrderTrackingInstalled) return;
  window.cmssOrderTrackingInstalled = true;
  function publish(name, hub, action) {
    try {
      var shopify = window.Shopify;
      if (!shopify || shopify.designMode || !shopify.customerPrivacy || !shopify.customerPrivacy.analyticsProcessingAllowed()) return;
      if (!shopify.analytics || typeof shopify.analytics.publish !== 'function') return;
      var result = shopify.analytics.publish(name, {
        section: 'homepage_ordering',
        action: action,
        version: '2026_v1',
        preview: hub.dataset.themeRole !== 'main'
      });
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return true;
    } catch (error) {}
  }
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('[data-cmss-order-hub] a[data-order-action]');
    if (!link) return;
    publish('cmss:ordering_click', link.closest('[data-cmss-order-hub]'), link.dataset.orderAction);
  });
  var seen = new WeakSet();
  var observer;
  function observe() {
    if (!('IntersectionObserver' in window)) return;
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 1 || seen.has(entry.target)) return;
        var hub = entry.target.closest('[data-cmss-order-hub]');
        if (!publish('cmss:ordering_view', hub, 'view')) return;
        seen.add(entry.target);
        observer.unobserve(entry.target);
      });
    }, {threshold: 1});
    document.querySelectorAll('[data-cmss-order-hub] .cmss-order-hub__heading').forEach(function (heading) { observer.observe(heading); });
  }
  observe();
  if (window.Shopify && !Shopify.customerPrivacy && typeof Shopify.loadFeatures === 'function') {
    Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) observe(); });
  }
  document.addEventListener('visitorConsentCollected', observe);
  document.addEventListener('shopify:section:load', observe);
})();

  } catch(e) { console.error(e); }
})();
})();
